export const CRM_REDIRECT = 'CRM_REDIRECT'
export const CRM_ADD_NEW_LEAD_REQUEST = 'CRM_ADD_NEW_LEAD_REQUEST'
export const CRM_ADD_NEW_LEAD_SUCCESS = 'CRM_ADD_NEW_LEAD_SUCCESS'
export const CRM_ADD_NEW_LEAD_ERROR = 'CRM_ADD_NEW_LEAD_ERROR'
export const CRM_FETCH_LEADS = 'CRM_FETCH_LEADS'
export const CRM_FETCH_LEAD = 'CRM_FETCH_LEAD'
export const CRM_DELETE_LEAD = 'CRM_DELETE_LEAD'
export const CRM_ADD_NEW_LEAD_ACTION_REQUEST = 'CRM_ADD_NEW_LEAD_ACTION_REQUEST'
export const CRM_ADD_NEW_LEAD_ACTION_SUCCESS = 'CRM_ADD_NEW_LEAD_ACTION_SUCCESS'
export const CRM_ADD_NEW_LEAD_ACTION_ERROR = 'CRM_ADD_NEW_LEAD_ERROR_ACTION'
export const CRM_DELETE_LEAD_ACTION_REQUEST = 'CRM_DELETE_LEAD_ACTION_REQUEST'
export const CRM_DELETE_LEAD_ACTION_SUCCESS = 'CRM_DELETE_LEAD_ACTION_SUCCESS'
export const CRM_DELETE_LEAD_ACTION_ERROR = 'CRM_DELETE_LEAD_ACTION_ERROR'
export const CRM_CHANGE_LEAD_ACTION_NAME = 'CRM_CHANGE_LEAD_ACTION_NAME'
export const CRM_POST_LEAD_ACTION_NAME_REQUEST = 'CRM_POST_LEAD_ACTION_NAME_REQUEST'
export const CRM_POST_LEAD_ACTION_NAME_SUCCESS = 'CRM_POST_LEAD_ACTION_NAME_SUCCESS'
export const CRM_POST_LEAD_ACTION_NAME_ERROR = 'CRM_POST_LEAD_ACTION_NAME_ERROR'
export const CRM_LEAD_ACTION_STATUS_CHANGE_MODAL_CLOSE = 'CRM_LEAD_ACTION_STATUS_CHANGE_MODAL_CLOSE'
export const CRM_LEAD_ACTION_STATUS_CHANGE = 'CRM_LEAD_ACTION_STATUS_CHANGE'
export const CRM_FETCH_POWIATY = 'CRM_FETCH_POWIATY'
export const CRM_FETCH_OPERATORS = 'CRM_FETCH_OPERATORS'
export const CRM_POWIAT_CHANGE = 'CRM_POWIAT_CHANGE'
export const CRM__POWIAT_CHANGE = 'CRM__POWIAT_CHANGE'
export const CRM_ADD_NEW_LEAD_ALERT_SHOWN = 'CRM_ADD_NEW_LEAD_ALERT_SHOWN'
export const CRM_SET_ZRODLA_KONTAKTU_OPTIONS = 'CRM_SET_ZRODLA_KONTAKTU_OPTIONS'
export const CRM_LEAD_EDIT_CHECK_PREFETCH = 'CRM_LEAD_EDIT_CHECK_PREFETCH'
export const CRM_LEAD_EDIT_RESET_PREFETCH = 'CRM_LEAD_EDIT_RESET_PREFETCH'
export const CRM_POST_LEAD_ACTION_REQUEST = 'CRM_POST_LEAD_ACTION_REQUEST'
export const CRM_POST_LEAD_ACTION_SUCCESS = 'CRM_POST_LEAD_ACTION_SUCCESS'
export const CRM_POST_LEAD_ACTION_ERROR = 'CRM_POST_LEAD_ERROR_ACTION'
export const CRM_IMPORT_FILE_SUBMIT = 'CRM_IMPORT_FILE_SUBMIT'
export const CRM_IMPORT_FILE_SUCCESS = 'CRM_IMPORT_FILE_SUCCESS'
export const CRM_IMPORT_FILE_ERROR = 'CRM_IMPORT_FILE_ERROR'
export const CRM_TYPY_IMPORTOW_SUCCESS = 'CRM_TYPY_IMPORTOW_SUCCESS'
export const CRM_SELECT_IMPORT = 'CRM_SELECT_IMPORT'
export const CRM_CONTACT_LIST_FILTER_CHANGE = 'CRM_CONTACT_LIST_FILTER_CHANGE'
export const CRM_CONTACT_LIST_SORT_CHANGE = 'CRM_CONTACT_LIST_SORT_CHANGE'
export const CRM_CONTACT_LIST_RESIZE_CHANGE = 'CRM_CONTACT_LIST_RESIZE_CHANGE'
export const CRM_CONTACT_LIST_CONFIG_SAVE_TO_LOCAL_STORAGE = 'CRM_CONTACT_LIST_CONFIG_SAVE_TO_LOCAL_STORAGE'
export const CRM_CONTACT_LIST_CONFIG_GET_FROM_LOCAL_STORAGE = 'CRM_CONTACT_LIST_CONFIG_GET_FROM_LOCAL_STORAGE'
export const CRM_CONTACT_LIST_CONFIG_UPDATE = 'CRM_CONTACT_LIST_CONFIG_UPDATE'